import { captureException } from "@sentry/react";

/** Indicates whether specified value is a string that isn't empty and does not consist only of white-space characters */
export function isNotEmptyOrWhiteSpace(value: unknown): value is string {
    return !isEmptyOrWhiteSpace(value);
}

/** Indicates whether a specified value is non-string, or an empty string, or consists only of white-space characters */
export function isEmptyOrWhiteSpace(value: unknown) {
    return !value || typeof value !== "string" || value.trim() === "";
}

// copy text to clipboard
export const copyTextToClipboard = (text: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (navigator.clipboard?.writeText) {
        return navigator.clipboard.writeText(text);
    } else {
        // Fallback for browsers that don't support clipboard.writeText
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        try {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            document.execCommand("copy");

            document.body.removeChild(textarea);
            return Promise.resolve();
        } catch (error) {
            const errorResult = new Error("Failed to copy text to clipboard", { cause: error });
            captureException(errorResult, { extra: { text } });
            document.body.removeChild(textarea);

            return Promise.reject(errorResult);
        }
    }
};
